<template>
<div>
    <invoice-form ref="invoiceForm"></invoice-form>
    <preview-kktc-e-invoice-form :getCreateKktcInvoiceList="getCreateKktcInvoiceList" ref="previewKktcEInvoiceForm"></preview-kktc-e-invoice-form>

      <div class="custom-search">
         <b-row>
            <b-col class="col-md-3 mb-1">
                <label for="invoice-payment-date-input">{{ $t('createKktcEInvoice.payment_start_date') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-datepicker id="invoice-payment-date-input" @input="getCreateKktcInvoiceList()" :placeholder="$t('createKktcEInvoice.payment_start_date')" size="sm" v-model="paymentStartDate" class="mb1" defaultDate: null reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                </div>
            </b-col>
            <b-col class="col-md-3 mb-1">
                <label for="invoice-payment-date-input">{{ $t('createKktcEInvoice.payment_end_date') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-datepicker id="invoice-payment-date-input" @input="getCreateKktcInvoiceList()" :placeholder="$t('createKktcEInvoice.payment_end_date')" size="sm" v-model="paymentEndDate" class="mb1" defaultDate: null reset-button today-button :label-today-button="$t('dateTime.today')" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                </div>
            </b-col>

            <b-col class="col-md-6 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getCreateKktcInvoiceList()" @click="getCreateKktcInvoiceList()">{{ $t('createKktcEInvoice.list') }}</b-button>
                    <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="col-md-3 mb-1">
                <label for="invoice-debit-no-input">{{ $t('createKktcEInvoice.debit_no') }}</label>
                <b-form-input size="sm" v-model="debitNo" v-on:keyup.enter="getCreateKktcInvoiceList()" :placeholder="$t('createKktcEInvoice.debit_no')" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-md-3 mb-1">
                <label for="invoice-agent-name-input">{{ $t('createKktcEInvoice.agent_name') }}</label>
                <b-form-input size="sm" v-model="agentName" v-on:keyup.enter="getCreateKktcInvoiceList()" :placeholder="$t('createKktcEInvoice.agent_name')" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-md-3 mb-1">
                <b-form>
                    <label for="invoice-employee-input">{{ $t('createKktcEInvoice.employee') }}</label>
                    <b-form-select id="invoice-employee-input" :placeholder="$t('createKktcEInvoice.employee')" size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                </b-form>
            </b-col>

            <b-col class="col-md-3 mb-1">
                <b-form>
                    <label for="invoice-reportType-input">{{ $t('createKktcEInvoice.report_type') }}</label>
                    <b-form-select id="invoice-reportType-input" :placeholder="$t('createKktcEInvoice.report_type')" size="sm" v-model="reportTypeSelect" value-field="id" text-field="name" :options="reportTypeOption" />
                </b-form>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table id="createKktcEInvoiceTable" ref="createKktcEInvoiceTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
      enabled: true,
      externalQuery: searchTerm
    }" :select-options="{
      enabled: false,
      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
      selectionInfoClass: 'custom-class',
      selectionText: 'rows selected',
      clearSelectionText: 'clear',
      disableSelectInfo: true, // disable the select info panel on top
      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    }" :pagination-options="{
      enabled: true,
      perPage: pageLength
    }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'debitNo'" class="text-nowrap">
                {{ $t('createKktcEInvoice.debit_no') }}
            </span>
            <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                {{ $t('createKktcEInvoice.amount') }}
            </span>
            <span v-else-if="props.column.field === 'proformaDate'" class="text-nowrap">
                {{ $t('createKktcEInvoice.payment_date') }}
            </span>
            <span v-else-if="props.column.field === 'employee'" class="text-nowrap">
                {{ $t('createKktcEInvoice.employee') }}
            </span>
            <span v-else-if="props.column.field === 'note'" class="text-nowrap">
                {{ $t('createKktcEInvoice.note') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->

            <span v-if="props.column.field === 'clientAccounting'">
                <span>
                    {{ props.row.clientAccounting }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'client'">
                <span>
                    {{ props.row.client }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'proformaDate'">
                <span>
                    {{$formatFn(props.row.proformaDate) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'total'">
                <span>
                    {{$formatMoney(props.row.total) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                </span>
                <span>
                    <b-button v-b-tooltip.html :title="$t('createKktcEInvoice.preview')" v-b-modal.modal-top variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="previewKktcEInvoice(props.row.id,props.row.clientAccountingId)">
                        <feather-icon icon="FileTextIcon" />
                    </b-button>
                </span>
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getCreateKktcInvoiceList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            total: 0,
            pageLength: 10,
            dir: false,
            pageNo: 1,
            columns: [{
                    label: this.$t('createKktcEInvoice.debit_no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('createKktcEInvoice.accounting_no'),
                    field: `clientAccounting`,
                },
                {
                    label: this.$t('createKktcEInvoice.agent_name'),
                    field: `client`,
                },
                {
                    label: this.$t('createKktcEInvoice.send_type'),
                    field: `invoiceSendType`,
                },
                {
                    label: this.$t('createKktcEInvoice.invoice_title'),
                    field: `header`,
                },

                {
                    label: this.$t('createKktcEInvoice.amount'),
                    field: `total`,
                },
                {
                    label: this.$t('createKktcEInvoice.currency_code'),
                    field: `currencyCode`,
                },
                {
                    label: this.$t('createKktcEInvoice.payment_date'),
                    field: `proformaDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('createKktcEInvoice.employee'),
                    field: `employee`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            debitNo: '',
            agentName: '',
            employeeSelect: 0,
            employeeOption: [],
            paymentStartDate: null,
            paymentEndDate: null,
            reportTypeSelect: 1,
            reportTypeOption: [
                { name: "Fatura Kesilecekler", id: 1 },
                { name: "Computer Packages", id: 2 },
                { name: "Fatura Kesilenler", id: 3 }
            ]   
        }
    },
    mounted() {
        this.paymentStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        this.paymentEndDate = new Date()
        this.getCreateKktcInvoiceList()
    },
    methods: {
        async getInfo(id) {
            this.$refs.invoiceForm.showInfo(id)
        },
        async previewKktcEInvoice(id) {
            this.$refs.previewKktcEInvoiceForm.showInfo(id)
        },        
        getCreateKktcInvoiceList() {
            this.rows = []
            const controller = {
                name: 'Invoice',
                actionName: 'GetCreateKktcEInvoiceList'
            }
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                debitNo: this.debitNo,
                agentName: this.agentName,
                employeeId: this.employeeSelect,
                accountNo: this.accountNo,
                documentDateStart: this.paymentStartDate,
                documentDateEnd: this.paymentEndDate,
                reportType: this.reportTypeSelect
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    response.data.invoiceList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.employeeOption = response.data.employeeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'Invoice',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Faturalar", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
